export default __webpack_public_path__ + "static/heroUnboxing-ac04a4e9005de8cb9294b3dca1ff166e.jpg";